import Vue from 'vue'
// import axios from '../api/axios'
import store from '../store'

// axios.install(Vue)
import ApiUrls from '@/api/apiUrls'
import axiosDef from 'axios'
import { Base64 } from 'js-base64'
import dayjs from 'dayjs'

export default {
  install(Vue, options) {
    //表格头部颜色
    Vue.prototype.tableHeaderColor= function({ rowIndex }) {
      if (rowIndex === 0) {
          return 'background: #fafafa;color: #000;font-weight:800;'
      }
    },
    Vue.prototype.clear = function(form) {
      form.resetFields()
    },  
    //判断数组内元素是否全相同 
    Vue.prototype.isAllEqual = function(array) {
      if (array.length > 0) {
          return !array.some(function (value, index) {
              return value !== array[0];
          });
      } else {
          return true;
      }
    }, 
    //快速查找数组中的某个元素并返回下标
    Vue.prototype.isHasElementOne = function(arr,value) {
      for(var i = 0,vlen = arr.length; i < vlen; i++){
        if(arr[i].SupportTypeName == value){
          return i;
        }
        }
          return -1;
    },
    //验证重复元素，有重复返回true；否则返回false
    Vue.prototype.isRepeatArray = function(arr) {
      var hash = {};
      for(var i in arr) {
        if(hash[arr[i]]) {
          return true;
        }
        // 不存在该元素，则赋值为true，可以赋任意值，相应的修改if判断条件即可
        hash[arr[i]] = true;
      }
      return false;
    }
    //获取状态
    Vue.prototype.StateTransform = function(Val,ApprovalVal) {
      switch (Val) {
        case 0:
          return '未提交'
          break;
        case 1:
          return '待审批'
          break;
        case 2:
          return '已生效'
          break;
        case 3:
          return '审批中'
          break;
        case 4:
          return '已作废'
          break;
        case 5:
          if(ApprovalVal==3){
            return '已驳回'
          }else if(ApprovalVal==2){
            return '审批通过'
          }else if(ApprovalVal==7){
            return '审批处理中'
          }          
          break;
        case 6:
          return '续签变更'
          break;
        case 7:
          return '审批处理中'
          break;
        case 8:
          return '已签字'
          break;
        case 10:
            return '已撤回'
            break;
        case '':
          return ''
          break;
      }
    },
    //通用子组件，空模板下载
    Vue.prototype.downloadTem = function(apiurl, fileType) {
      const loading = this.$loading({
        lock: true,
        text: '正在进行文件导出',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      axiosDef.get(apiurl, {
        params: {},
        headers: {
          'Content-Type': 'application/json',
          'Token': 'Bearer ' + (window.localStorage.getItem('token') || '')
        },
        responseType: 'blob'
      }).then(function(res) {
          if (res.status == 200) {
            var fileName = res.headers['content-disposition']
            let fileNameIndex = fileName.indexOf('utf-8?B?')
            if (fileNameIndex != -1) {
              fileName = fileName.substr(fileNameIndex + 8)
              fileName = Base64.decode(fileName)//解码后的文件名
            } else {
              fileName = fileName.substr(fileName.indexOf('filename=') + 9)
            }
            var content = res.data
            var content = res.data
            var csvData = new Blob([content], { type: 'text/csv' })
            // for IE
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(csvData, fileName)
            }
            // for Non-IE (chrome, firefox etc.)
            else {
              var a = document.createElement('a')
              document.body.appendChild(a)
              a.style = 'display: none'
              var url = window.URL.createObjectURL(csvData)
              a.href = url
              a.download = fileName
              a.click()
              a.remove()
              window.URL.revokeObjectURL(url)
            }
          }
          loading.close()
        })
    },
    //excel，数据导出
    Vue.prototype.downloadPostTem = function(apiurl, fileType, data) {
      const loading = this.$loading({
        lock: true,
        text: '正在进行文件导出',
        background: 'rgba(0, 0, 0, 0.8)'
      })
      axiosDef.post(apiurl,data, {
        headers: {
          'Content-Type': 'application/json',
          'Token': 'Bearer ' + (window.localStorage.getItem('token') || ''),
          'appToken': 'Bearer ' + (window.localStorage.getItem('token') || '')
        },
        responseType: 'blob'
      }).then(function(res) { 
          console.log(res)
          if (res.status == 200) {
          //   var fileName = res.headers['content-disposition']
          //   let fileNameIndex = fileName.indexOf('utf-8?B?')
          //   if (fileNameIndex != -1) {
          //     fileName = fileName.substr(fileNameIndex + 8)
          //     fileName = Base64.decode(fileName)//解码后的文件名
          //   } else {
          //     fileName = fileName.substr(fileName.indexOf('filename=') + 9)
          //   }
          //   var content = res.data
          //   var csvData = new Blob([content], { type: 'application/pdf;charset=UTF-8'})
          //   // for IE
          //   if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          //     window.navigator.msSaveOrOpenBlob(csvData, fileName)
          //   }
          //   // for Non-IE (chrome, firefox etc.)
          //   else {
          //     var a = document.createElement('a')
          //     document.body.appendChild(a)
          //     a.style = 'display: none'
          //     var url = window.URL.createObjectURL(csvData)
          //     a.href = url
          //     a.download = fileName
          //     a.click()
          //     a.remove()
          //     window.URL.revokeObjectURL(url)
          //   }
            var excelBlob = new Blob([res.data], {
              type: "application/vnd.ms-excel"
            });
            var fileName = fileType;
            
            var oa = document.createElement("a");
            oa.href = URL.createObjectURL(excelBlob);
            oa.download = fileName;
            document.body.appendChild(oa);
            oa.click();
          }
          
          loading.close()
        })
    },
    Vue.prototype.openLoading = function() {
      const loading = this.$loading({           // 声明一个loading对象
        lock: true,                             // 是否锁屏
        text: '正在进行数据提交，请耐心等待！',                     // 加载动画的文字
        background: 'rgba(0, 0, 0, 0.8)'       // 背景颜色
      })
      //setTimeout(function() {                  // 设定定时器，超时5S后自动关闭遮罩层，避免请求失败时，遮罩层一直存在的问题
        //loading.close()                        // 关闭遮罩层
      //}, 5000)
      return loading
    },
    /**
     * 文件下载
     * @param src 下载地址
     * @param name 文件名称
     */
    Vue.prototype.downFile = function(src) {
      var eleLink = document.createElement('a');
      eleLink.href = ApiUrls.File_DownLoadFile+src;
      eleLink.style.display = 'none';
      document.body.appendChild(eleLink);
      eleLink.click();
      document.body.removeChild(eleLink);
    },
    Vue.prototype.timeFormat= function(time, format) {
      if(time){
        return dayjs(time).format(format)
      }else{
        return ''
      }
    },
    Vue.prototype.monthUper= function(time) {
      let monData = {
        '01': '一月',
        '02': '二月',
        '03': '三月',
        '04': '四月',
        '05': '五月',
        '06': '六月',
        '07': '七月',
        '08': '八月',
        '09': '九月',
        '10': '十月',
        '11': '十一月',
        '12': '十二月',
        'before': '半年前'
      }
      let monStr = ''
      if(time){
        if(time.includes('-')){
          monStr = time.split('-')[1]
        }else{
          monStr = time
        }
      }
      console.log('time', time);
      
      if(monStr){
        return monData[monStr]
      }else{
        return ''
      }
    }
  }
}
